module.exports = "<app-mmetatag [page]=\"BLOG\"></app-mmetatag>\n<div class=\"container-outer-box\">\t\n\t\t<div class=\"container\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-lg-9 col-md-12\">          \n          <app-bloglist [option]=option></app-bloglist>\n        </div>\n        <div class=\"col-lg-3 col-md-12\">\t\n           \n            <app-right-sidebar2 [user]=userData></app-right-sidebar2>\n        </div>\n     </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/blog/blog.component.html
// module id = ../../../../../src/app/home/blog/blog.component.html
// module chunks = common